<template>
    <div>
        <sample-header></sample-header>
        <terms-content :code="code"></terms-content>
        <sample-footer></sample-footer>
    </div>
</template>
<script>
import SampleHeader from "@/components/layout/SampleHeader";
import SampleFooter from "@/components/layout/SampleFooter";
const TermsContent = () => import("@/components/terms/TermsContent");
export default {
  props: ["code"],
  components: { SampleHeader, SampleFooter, TermsContent }
};
</script>
<style>
</style>
